import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { read } from "Helpers/LocalStorage";
import { GetAllShishe, disableShishe, insertShishe } from "Stores/actions";
import showNotify from "Helpers/Notify";
import { shisheColumn } from "Constants/TableColumns";
import cellEditFactory from "react-bootstrap-table2-editor";
import * as R from "ramda";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import millimeterMask from "Components/Input/components/millimeterMask";

function ShisheManage() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { shishe, shishePagination } = useSelector((state) => ({
    shishe: state.shishe.shishe,
    shishePagination: state.shishe.shishePagination,
  }));
  const [sizePerPage, setSizePerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [tblData, setTblData] = useState(shishe);
  const [total, setTotal] = useState(1);
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [controls, setControls] = useSetState({
    shisheName: {
      type: "text",
      value: "",
      row: 1,
      validation: {
        required: true,
      },
    },
    thick: {
      type: "millimeter",
      value: 4,
      row: 1,
      validation: {
        required: true,
        isNumeric: true,
        min: 4,
        minLength: 1,
        maxLength: 3,
      },
    },
    price: {
      type: "price",
      value: "",
      row: 1,
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
    },
    nameSearch: {
      type: "search",
      value: null,
      row: 2,
      validation: null,
      col: 3,
    },
  });

  const onEnter = async () => {
    onClear();
    await onGetAllShishe(1, 5, "");
  };

  const onClear = () => {
    setCheckValid(false);
    setFormValid({ shisheName: false, thick: true, price: false });
    setControls({ shisheName: { value: "" } });
    setControls({ thick: { value: 4 } });
    setControls({ price: { value: "" } });
    setControls({ nameSearch: { value: null } });
  };

  useEffect(() => {
    if (shishe) {
      setTblData(shishe);
      setTotal(shishePagination.Total);
      setCurrentPage(shishePagination.Page);
      setSizePerPage(shishePagination.Limit);
    }
  }, [shishe, shishePagination]);

  const handleDialog = () => setOpenDialog(!openDialog);

  const setValue = async (name, value, validation) => {
    setControls({ [name]: { value: value } });
    if (name !== "nameSearch")
      setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { shisheName, price, thick } = controls;
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Name: shisheName.value,
          Price: +price.value,
          Thick: +thick.value,
        };
        setLoading(true);
        await dispatch(insertShishe(data));
        onClear();
        await onGetAllShishe();
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      setCheckValid(true);
    }
  };

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
    if (column.dataField === "Disable") {
      const updateNewValue = JSON.parse(newValue);
      if (oldValue !== updateNewValue) {
        try {
          setLoading(true);
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: +row.Id,
            Disable: updateNewValue,
          };
          await dispatch(disableShishe(data));
          await onGetAllShishe();
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    }
  };

  const onTableChange = async (type, { page, sizePerPage }) => {
    setLoading(true);
    if (type === "pagination") {
      try {
        await onGetAllShishe(page, sizePerPage);
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    setLoading(false);
  };

  const onSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setCurrentPage(1);
    await onGetAllShishe(1, sizePerPage, controls.nameSearch.value);
    setLoading(false);
  };

  const onClearSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setControls({ nameSearch: { value: "" } });
    setCurrentPage(1);
    await onGetAllShishe(1, sizePerPage, "");
    setLoading(false);
  };

  const onGetAllShishe = async (
    Page = currentPage,
    Limit = sizePerPage,
    data = "NODATA"
  ) => {
    setLoading(true);
    try {
      let dataSearch = null;
      if (data !== "NODATA") {
        if (data !== "") dataSearch = { Name: data };
      } else if (controls.nameSearch.value !== "")
        dataSearch = {
          Name: controls.nameSearch.value,
        };
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        Limit,
        Page,
        ...dataSearch,
      };
      await dispatch(GetAllShishe(params));
    } catch (err) {
      console.error("[onGetAllShishe]", err);
    }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  };

  const onExit = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <MuiButton
        loading={loading}
        color="secondary"
        title={<Translator id={"glass_manage"} />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        onClose={handleDialog}
        fullWidth
        maxWidth="md"
      >
        <div className="dialogHeader">
          <p>{<Translator id={"glass_manage"} />}</p>
        </div>
        <DialogContent id="content-dialog-manager">
          <BackDropLoading loading={loading} />
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              className="text-center py-2 mb-3"
              style={{ backgroundColor: "#E4E8E8" }}
            >
              <strong>
                <Translator id="newShishe" noSpan />
              </strong>
            </Grid>
            <Grid container spacing={2} className="px-3 d-flex mb-2">
              {Object.keys(controls)
                .filter((key) => controls[key].row === 1)
                .map((key, index) => {
                  return (
                    <Grid item key={key + index} className="flex-grow-1">
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        placeholder={t(key)}
                        validation={controls[key].validation}
                        checkValid={checkValid}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        inputComponent={controls[key].type === "millimeter" ? millimeterMask : ""}
                        endIcon={
                          controls[key].type === "price" ? (
                            <Translator id="moneyUnit" />
                          ) : controls[key].type === "millimeter" ? (
                            <Translator id="millimeter" />
                          ) : (
                            ""
                          )
                        }
                        minLength={controls[key]?.validation?.minLength}
                        maxlength={controls[key]?.validation?.maxLength}
                      />
                    </Grid>
                  );
                })}
              <Grid
                item
                className="d-flex justify-content-center align-items-center flex-grow-1 flex-sm-grow-0"
              >
                <MuiButton
                  loading={loading}
                  color="primary"
                  title={<Translator id="ezafe_be_list" />}
                  onClick={onFinish}
                  fullwidthOnSm
                  disabled={read("ShisheRules").accessRegister === false}
                />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              className="text-center py-2 mb-3"
              style={{ backgroundColor: "#E4E8E8" }}
            >
              <strong>
                <Translator id="glassTbl" noSpan />
              </strong>
            </Grid>
            <Grid container>
              <Grid item sm={6} xs={12} className="mb-2">
                <Input
                  setValue={setValue.bind(this)}
                  name="nameSearch"
                  value={
                    controls.nameSearch.value ? controls.nameSearch.value : ""
                  }
                  placeholder={t("nameSearch")}
                  type="search"
                  onSearch={onSearch}
                  onClearSearch={onClearSearch}
                />
              </Grid>
              <Grid item xs={12}>
                <RemoteTable
                  data={tblData}
                  keyField="num"
                  columns={shisheColumn}
                  loading={loading}
                  page={currentPage}
                  sizePerPage={5}
                  sizePerPageList={[{ text: "5", value: 5 }]}
                  totalSize={total}
                  onTableChange={onTableChange}
                  // title={<Translator id="glassTbl" />}
                  noTitle
                  cellEdit={cellEditFactory({
                    mode: "click",
                    blurToSave: true,
                    beforeSaveCell: (oldValue, newValue, row, column, done) =>
                      BeforeSaveCell(oldValue, newValue, row, column, done),
                  })}
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ShisheManage;
